module.exports = __webpack_public_path__ + "img/goal_m03-2.27d49009.jpg";